import Layout from '@/layout'

export const routerList = [
  {
    path: '/report',
    component: Layout,
    meta: {
      title: '报表',
      icon: 'icon-chanpinPIguanli-01'
    },
    alwaysShow: true,
    children: [
      {
        path: '/report/project',
        component: () => import('@/views/Report/Project'),
        name: 'ReportProject',
        meta: { title: '项目报表', affix: false }
      },
      {
        path: '/report/user',
        component: () => import('@/views/Report/User'),
        name: 'ReportUser',
        meta: { title: '费用报表', affix: false }
      },
      {
        path: '/report/tax',
        component: () => import('@/views/Report/Tax'),
        name: 'ReportTax',
        meta: { title: '税务报表', affix: false }
      },
      {
        path: '/report/projectDetail',
        component: () => import('@/views/Report/ProjectDetail'),
        name: 'ReportProjectDetail',
        meta: { title: '项目报表详情', affix: false },
        hidden: true
      }
    ]
  }
]
